import { render, staticRenderFns } from "./AddSB.vue?vue&type=template&id=3c0250f4&"
import script from "./AddSB.vue?vue&type=script&lang=js&"
export * from "./AddSB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports